if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');
        this.closeButton = this.querySelector('[data-sticky-atc-close]');
        this.isClosed = false;

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
        }
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.variantIdSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          if (this.isClosed) return;
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (this.isClosed) return;
              this.container.classList.toggle('sticky-atc-bar--show', !entry.isIntersecting);
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
      }

      checkDevice() {
        if (this.isClosed) {
          document.documentElement.style.setProperty('--sticky-atc-bar-height', '0px');
          return;
        }
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      handleCloseClick(event) {
        event.preventDefault();
        this.isClosed = true;
        this.container.classList.remove('sticky-atc-bar--show');
        this.container.classList.add('sticky-atc-bar--dismissed');
        document.body.classList.remove('sticky-atc-bar-enabled');
        document.documentElement.style.setProperty('--sticky-atc-bar-height', '0px');
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;

        const priceWrapper = this.querySelector('.sticky-atc-bar__price');
        const currentPrice = this.querySelector('.sticky-atc-bar__price-current');
        const compareAtPrice = this.querySelector('.sticky-atc-bar__price-compare');
        const budgetPrice = this.querySelector('.sticky-atc-bar__price-budget');
        if (!priceWrapper || !currentPrice) return;

        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
        const isOnSale = compare_at_price && compare_at_price > price;
        const showSaveBudget = this.dataset.showSaveBudget === 'true';
        const budgetLabel = this.dataset.budgetLabel || 'SAVE';
        const savedAmount = Math.max((compare_at_price || 0) - price, 0);

        currentPrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        priceWrapper.classList.toggle('is-on-sale', isOnSale);
        priceWrapper.classList.toggle('is-sold-out', !this.currentVariant.available);

        if (compareAtPrice) {
          if (isOnSale) {
            compareAtPrice.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`;
            compareAtPrice.classList.remove('hidden');
          } else {
            compareAtPrice.innerHTML = '';
            compareAtPrice.classList.add('hidden');
          }
        }

        if (budgetPrice) {
          if (isOnSale && showSaveBudget && savedAmount > 0) {
            budgetPrice.innerHTML = `${this.escapeHtml(budgetLabel)} ${FoxTheme.Currency.formatMoney(savedAmount, moneyFormat)}`;
            budgetPrice.classList.remove('hidden');
          } else {
            budgetPrice.textContent = '';
            budgetPrice.classList.add('hidden');
          }
        }

        const unitPriceWrapper = this.querySelector('.f-price__unit-wrapper');
        if (!unitPriceWrapper) return;
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');
        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      escapeHtml(value) {
        if (value == null) return '';

        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
